import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckReviewService extends ApiService {

  public checkMemdata(payLoad: any): Observable<any> {
    return this.post<any>(
      this.replacePathInfo(ROUTES.REVIEW_CHECK),
      {
        body: payLoad,
      }
    );
  }
}
